import { render, staticRenderFns } from "./Panorama.vue?vue&type=template&id=080a4344&scoped=true"
import script from "./Panorama.vue?vue&type=script&lang=js"
export * from "./Panorama.vue?vue&type=script&lang=js"
import style0 from "./Panorama.vue?vue&type=style&index=0&id=080a4344&prod&scoped=true&lang=css"
import style1 from "./Panorama.vue?vue&type=style&index=1&id=080a4344&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080a4344",
  null
  
)

export default component.exports